(function () {
  const cache = {};

  function resolveLocaleUrl(url, locale) {
    const code = (locale || 'es').split('-')[0].toLowerCase();
    if (!code || code === 'es') return url;
    if (new RegExp('\\.' + code + '\\.json', 'i').test(url)) return url;
    return url.replace(/\.json(\?.*)?$/, '.' + code + '.json');
  }

  async function loadData(url) {
    if (cache[url]) return cache[url];
    const res = await fetch(url);
    if (!res.ok) throw new Error('Specs fetch failed');
    cache[url] = await res.json();
    return cache[url];
  }

  async function loadLocalized(url, locale) {
    const localized = resolveLocaleUrl(url, locale);
    if (localized !== url) {
      try {
        const res = await fetch(localized);
        if (res.ok) {
          cache[localized] = await res.json();
          return cache[localized];
        }
      } catch (e) {}
    }
    return loadData(url);
  }

  function renderSpecs(list, specs, labels) {
    list.replaceChildren();
    const rows = [
      [labels.fabric, specs.fabric],
      [labels.cut, specs.cut],
      [labels.occasion, specs.occasion],
      [labels.care, specs.care],
    ];
    rows.forEach(([label, value]) => {
      if (!value) return;
      const row = document.createElement('div');
      row.className = 'product-specs__row';
      const dt = document.createElement('dt');
      dt.textContent = label;
      const dd = document.createElement('dd');
      dd.textContent = value;
      row.appendChild(dt);
      row.appendChild(dd);
      list.appendChild(row);
    });
  }

  async function initBlock(block) {
    const handle = block.dataset.productHandle;
    const dataUrl = block.dataset.specsUrl;
    const list = block.querySelector('[data-specs-list]');
    if (!handle || !dataUrl || !list) return;

    try {
      const data = await loadLocalized(dataUrl, block.dataset.locale);
      const specs = data[handle];
      if (!specs || (!specs.fabric && !specs.cut && !specs.occasion && !specs.care)) {
        block.hidden = true;
        return;
      }
      renderSpecs(list, specs, {
        fabric: block.dataset.labelFabric || 'Tejido',
        cut: block.dataset.labelCut || 'Corte',
        occasion: block.dataset.labelOccasion || 'Ocasión',
        care: block.dataset.labelCare || 'Cuidado',
      });
    } catch (e) {
      block.hidden = true;
    }
  }

  function boot() {
    document.querySelectorAll('.product-specs[data-product-handle]').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
